import React, { useContext, useEffect, useState } from 'react'
import Alert from '@mui/material/Alert'
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import API from '../../../../../services/API'
import { EventMetaContext } from '../../SingleEvent'
import EmployeeSelector from '../../../EmployeeSelector'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'

const VehicleAddPopup = ({
  existingVehicle,
  eventStart,
  eventEnd,
  loadVehicles,
}) => {
  const [vehicleOptions, setVehicleOptions] = useState([])
  const [loadingVehicleOptions, setLoadingVehicleOptions] = useState(true)
  const [driverToEvent, setDriverToEvent] = useState(null)
  const [driverFromEvent, setDriverFromEvent] = useState(null)
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [payRate, setPayRate] = useState('')
  const [hourlyRate, setHourlyRate] = useState(true)
  const [start, setStart] = useState(eventStart ?? new Date())
  const [end, setEnd] = useState(eventEnd ?? new Date())
  const [vehicleUnavailable, setVehicleUnavailable] = useState(false)

  const { eventMeta } = useContext(EventMetaContext)

  useEffect(() => {
    setLoadingVehicleOptions(true)
    // Availability must reflect the booked window, not the whole event —
    // otherwise a vehicle already booked for one part of the event can never
    // be booked for another (back-to-back) window.
    API.post('/events/ops/availableVehicles', {
      startDate: start,
      endDate: end,
    })
      .then((res) => res.status === 200 && setVehicleOptions(res.data))
      .catch((e) => console.log(e))
      .finally(() => setLoadingVehicleOptions(false))
  }, [start, end])

  const handleSubmit = (e) => {
    e.preventDefault()
    setVehicleUnavailable(false)
    API.post('/fleet/vehicledeployment', {
      linkedEvent: eventMeta._id,
      start,
      end,
      driverTo: driverToEvent?.userAccount?._id,
      driverFrom: driverFromEvent?.userAccount?._id,
      vehicle: selectedVehicle._id,
    })
      // API.post('/events/assign-vehicle', {
      //   eventID: event._id,
      //   newVehicle: {
      //     vehicle: selectedVehicle._id,
      //     driverToEvent: driverToEvent?._id,
      //     driverFromEvent: driverFromEvent?._id,
      //     payRate,
      //     hourlyRate,
      //     unavailableDaysBefore: daysUnavailableBefore,
      //     unavailableDaysAfter: daysUnavailableAfter,
      //   },
      // })
      .then((res) => {
        if (res.status === 200) {
          loadVehicles()
        } else if (
          res.status === 400 &&
          res.data?.errorCode === 'AlreadyBooked'
        ) {
          setVehicleUnavailable(res.data.error)
        }
      })
      .catch((e) => console.log(e))
  }

  return (
    <Grid container spacing={2} component="form" onSubmit={handleSubmit}>
      <Grid item xs={12}>
        <Typography variant="title2">
          Assign a vehicle to {eventMeta?.title}
        </Typography>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Autocomplete
          value={selectedVehicle}
          options={vehicleOptions}
          loading={loadingVehicleOptions}
          getOptionLabel={(opt) =>
            `${opt.callSign}${opt.isBusy ? ' (Being Used)' : ''}`
          }
          isOptionEqualToValue={(a, b) => a._id === b._id}
          onChange={(e, value) => {
            setSelectedVehicle(value)
          }}
          getOptionDisabled={(opt) => opt.isBusy}
          fullWidth
          renderInput={(params) => (
            <TextField {...params} label="Vehicle" required />
          )}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <EmployeeSelector
          valueType="employee"
          excludeBannedFromEvents
          value={driverToEvent}
          label="Driver To Event"
          onChange={(e, newValue) => setDriverToEvent(newValue)}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <EmployeeSelector
          valueType="employee"
          excludeBannedFromEvents
          value={driverFromEvent}
          label="Driver From Event"
          onChange={(e, newValue) => setDriverFromEvent(newValue)}
        />
      </Grid>
      <Grid item container xs={12} lg={6}>
        <AnDateTimePicker
          date={start}
          onChange={(newDate) => setStart(newDate)}
          label="Booked From"
          fullWidth
        />
      </Grid>
      <Grid item container xs={12} lg={6}>
        <AnDateTimePicker
          date={end}
          onChange={(newDate) => setEnd(newDate)}
          label="Booked Until"
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <Stack gap={1}>
          {vehicleUnavailable && (
            <Alert severity="error" variant="filled">
              {vehicleUnavailable}
            </Alert>
          )}
          <Button variant="contained" color="success" type="submit" fullWidth>
            Submit
          </Button>
        </Stack>
      </Grid>
    </Grid>
  )
}

export default VehicleAddPopup
